import { AddonSection } from "./AddonSection";
import { DigitalRecipesToggle } from "./DigitalRecipesToggle";
import { RaatassOptOutSection } from "../RaatassOptOutSection";
import { DeliveriesPausedSnackbar } from "../DeliveriesPausedSnackbar";
import { YourMealbox } from "./YourMealbox";
import { SubscriptionStatusActive } from "./SubscriptionStatusActive";
import { SubscriptionOverview } from "./SubscriptionOverview";

export const AccountActive = () => {
  return (
    <div className="grid col-span-5 gap-6 md:gap-4 xl:gap-6 xl:grid-cols-9 md:grid-cols-5 xl:col-span-9">
      <div className="flex flex-col order-2 gap-6 xl:order-1 md:col-span-5 col-span-full xl:col-span-5">
        <YourMealbox />

        <AddonSection />

        <DigitalRecipesToggle />

        <RaatassOptOutSection />

        <SubscriptionStatusActive />
      </div>

      <div className="order-1 col-span-full md:col-span-5 xl:col-span-4 xl:col-start-6 xl:order-2 md:mb-2">
        <DeliveriesPausedSnackbar />

        <SubscriptionOverview />
      </div>
    </div>
  );
};
